import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleCommentEvent = {
  namespaced: true,

  state: {
    name: 'comment-event',
    
    comments: []
  },

  mutations,
  getters,
  actions
}

export default moduleCommentEvent;